export const IMAGE_LOADING = 'IMAGE_LOADING';
export const IMAGE_LOADED = 'IMAGE_LOADED';
export const IMAGE_ERROR = 'IMAGE_ERROR';

// SLD Spec: Default size for Marks without Size should be 6 pixels.
export const DEFAULT_MARK_SIZE = 6; // pixels
// SLD Spec: Default size for ExternalGraphic with an unknown native size,
// like SVG without dimensions, should be 16 pixels.
export const DEFAULT_EXTERNALGRAPHIC_SIZE = 16; // pixels

// QGIS Graphic stroke placement options
export const PLACEMENT_DEFAULT = 'PLACEMENT_DEFAULT';
export const PLACEMENT_FIRSTPOINT = 'PLACEMENT_FIRSTPOINT';
export const PLACEMENT_LASTPOINT = 'PLACEMENT_LASTPOINT';